import React from 'react';

export const pageMeta = {
  "name": "JS HTML Objects",
  "link": "/javascript/examples/html-objects"
};

export default function JavascriptExamplesHtmlObjects() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS HTML Objects</h2>
      <p>Route: /javascript/examples/html-objects</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
